import * as Sentry from '@sentry/react';

const DEFAULT_SENTRY_DSN =
  'https://85b58db1b1ccfe696097672dc94cc8da@o4511049670000640.ingest.us.sentry.io/4511581894017024';

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN || DEFAULT_SENTRY_DSN;

  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE,
    enabled: import.meta.env.PROD || import.meta.env.VITE_SENTRY_ENABLE_IN_DEV === 'true',
    sendDefaultPii: true,
  });
}
